"use client";

import { useRouter } from "next/navigation";
import { PhoneOff } from "lucide-react";

/**
 * What a plan WITHOUT a phone (Lite, or a trial of Lite) sees on a phone-side
 * screen in the mobile shell: what's missing, why, and the way to plans.
 */
export function NoPhonePlanNotice({ what = "calling" }: { what?: string }) {
  const router = useRouter();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-8 text-center">
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F2F2F7]">
        <PhoneOff className="h-6 w-6 text-[#8E8E93]" />
      </div>
      <p className="text-[17px] font-semibold text-[#1C1C1E]">Your plan doesn't include {what}</p>
      <p className="mt-1.5 text-[14px] leading-5 text-[#8E8E93]">
        Lite is the CRM without the dialers and calling. Upgrade to Basic to add the dialer, a local number and texting.
      </p>
      <button
        type="button"
        onClick={() => router.push("/m/settings/subscription")}
        className="mt-5 rounded-full bg-[#007AFF] px-5 py-2.5 text-[15px] font-medium text-white"
      >
        See plans
      </button>
    </div>
  );
}
